<template>
  <section id="home" class="hero">
    <div class="hero__bg"></div>
    <div class="hero__grid-lines"></div>
    <div class="hero__overlay"></div>
    <div class="hero__particles">
      <span v-for="n in 6" :key="n" class="hero__particle"></span>
    </div>

    <div class="container hero__wrap">
      <div class="hero__main">
        <div class="hero__content">
          <div class="hero__badge">
            <span class="hero__badge-icon">⚡</span>
            {{ company.slogan }}
          </div>
          <h1 class="hero__title">
            <span class="hero__title-line">智慧政务</span>
            <span class="hero__title-line hero__title-line--accent">解决方案提供商</span>
          </h1>
          <p class="hero__desc">{{ company.description }}</p>
          <div class="hero__actions">
            <router-link to="/contact" class="btn btn-primary btn-hero">
              预约演示
              <span class="hero__btn-arrow">→</span>
            </router-link>
            <router-link to="/products" class="btn btn-outline btn-hero">了解更多产品</router-link>
          </div>
        </div>

        <HeroVisual class="hero__visual" />
      </div>

      <div class="hero__stats">
        <div class="hero__stats-grid">
          <div v-for="(item, index) in stats" :key="item.label" class="hero__stat">
            <div class="hero__stat-value">{{ item.value }}</div>
            <div class="hero__stat-label">{{ item.label }}</div>
            <span v-if="index < stats.length - 1" class="hero__stat-divider" aria-hidden="true"></span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { company, stats } from '../data/site'
import HeroVisual from './HeroVisual.vue'

export default {
  name: 'HeroSection',
  components: { HeroVisual },
  data() {
    return { company, stats }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  padding: 88px 0 56px;
  overflow: hidden;
}

.hero__wrap {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.hero__main {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  padding-top: 16px;
}

.hero__content {
  padding: 0 0 0 8px;
  animation: fade-up 0.8s ease-out;
}

.hero__visual {
  animation: fade-up 0.8s ease-out 0.15s both;
}

.hero__bg {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(125deg, #001233 0%, #002d6e 42%, #0052d9 100%);
}

.hero__grid-lines {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  mask-image: radial-gradient(ellipse 80% 70% at 50% 50%, black 20%, transparent 80%);
}

.hero__overlay {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 50% 60% at 85% 40%, rgba(0, 163, 255, 0.25) 0%, transparent 55%),
    radial-gradient(ellipse 40% 50% at 10% 80%, rgba(0, 82, 217, 0.2) 0%, transparent 50%);
}

.hero__particles {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.hero__particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  animation: twinkle 3s ease-in-out infinite;
}

.hero__particle:nth-child(1) { top: 20%; left: 15%; animation-delay: 0s; }
.hero__particle:nth-child(2) { top: 35%; left: 75%; animation-delay: 0.5s; }
.hero__particle:nth-child(3) { top: 60%; left: 55%; animation-delay: 1s; }
.hero__particle:nth-child(4) { top: 75%; left: 25%; animation-delay: 1.5s; }
.hero__particle:nth-child(5) { top: 45%; left: 90%; animation-delay: 2s; }
.hero__particle:nth-child(6) { top: 15%; left: 45%; animation-delay: 2.5s; }

.hero__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 24px;
  padding: 8px 18px;
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 22px;
  backdrop-filter: blur(12px);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
}

.hero__badge-icon {
  font-size: 14px;
}

.hero__title {
  margin-bottom: 18px;
}

.hero__title-line {
  display: block;
  font-size: 46px;
  font-weight: 800;
  color: #fff;
  line-height: 1.15;
  letter-spacing: -0.5px;
}

.hero__title-line--accent {
  background: linear-gradient(90deg, #fff 0%, #7ec8ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero__desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.85;
  margin-bottom: 28px;
  max-width: 540px;
}

.hero__actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.btn-hero {
  padding: 13px 30px;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.btn-hero.btn-primary:hover {
  box-shadow: 0 6px 28px rgba(0, 82, 217, 0.35);
  transform: translateY(-2px);
}

.btn-hero.btn-outline:hover {
  background: rgba(255, 255, 255, 0.18);
  transform: translateY(-2px);
}

.hero__btn-arrow {
  transition: transform 0.25s;
}

.btn-hero.btn-primary:hover .hero__btn-arrow {
  transform: translateX(4px);
}

.hero__stats {
  padding: 0 8px;
  animation: fade-up 0.8s ease-out 0.3s both;
}

.hero__stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  overflow: hidden;
}

.hero__stat {
  position: relative;
  padding: 22px 20px;
  text-align: center;
  transition: background 0.25s;
}

.hero__stat:hover {
  background: rgba(255, 255, 255, 0.04);
}

.hero__stat-divider {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 36px;
  background: rgba(255, 255, 255, 0.12);
}

.hero__stat-value {
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 4px;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.hero__stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

@keyframes fade-up {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes twinkle {
  0%, 100% { opacity: 0.2; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.5); }
}

@media (max-width: 960px) {
  .hero__main {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .hero__visual {
    order: -1;
  }

  .hero__title-line {
    font-size: 34px;
  }
}

@media (max-width: 768px) {
  .hero {
    padding-bottom: 40px;
  }

  .hero__stats-grid {
    grid-template-columns: 1fr;
  }

  .hero__stat-divider {
    display: none;
  }

  .hero__stat + .hero__stat {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}
</style>
